<template>
    <span>
        <template v-if="currentCoordinatesFormatted">
            {{currentCoordinatesFormatted.lat}}, {{currentCoordinatesFormatted.lng}}
        </template>
    </span>
</template>

<script>
  export default {
    name: "MapCoordinates",
    props: {"coordinates": { type: Object}},
    computed: {
      currentCoordinatesFormatted: function () {
        let pos = this.coordinates;
        if (pos && pos.lat && pos.lng) {
          const latCardinal = pos.lat >= 0 ? "N" : "S";
          const longCardinal = pos.lng >= 0 ? "E" : "W";
          return {
            lat: pos.lat.toFixed(7),
            lng: pos.lng.toFixed(7)
          }
        } else {
          return undefined;
        }
      }
    }
  }
</script>

<style scoped>

</style>
